/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";
import Avatar from "themeComponents/Avatar";
import Badge from "themeComponents/Badge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

export function Author({ image, name, email }) {
  return (
    <Box display="flex" alignItems="center" px={1} py={0.5}>
      <Box mr={2}>
        <Avatar src={image} alt={name} size="sm" variant="rounded" />
      </Box>
      <Box display="flex" flexDirection="column">
        <Typography variant="button" fontWeight="medium">
          {name}
        </Typography>
        <Typography variant="caption" color="secondary">
          {email}
        </Typography>
      </Box>
    </Box>
  );
}

export function Function({ job, org }) {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="caption" fontWeight="medium" color="text">
        {job}
      </Typography>
      <Typography variant="caption" color="secondary">
        {org}
      </Typography>
    </Box>
  );
}

const authorsTableData = {
  columns: [
    { name: "author", align: "left" },
    { name: "function", align: "left" },
    { name: "status", align: "center" },
    { name: "employed", align: "center" },
    { name: "action", align: "center" },
  ],

  rows: [
    {
      author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
      function: <Function job="Manager" org="Organization" />,
      status: (
        <Badge variant="gradient" badgeContent="online" color="success" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          23/04/18
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
    {
      author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
      function: <Function job="Programator" org="Developer" />,
      status: (
        <Badge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          11/01/19
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
    {
      author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
      function: <Function job="Executive" org="Projects" />,
      status: (
        <Badge variant="gradient" badgeContent="online" color="success" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          19/09/17
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
    {
      author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
      function: <Function job="Programator" org="Developer" />,
      status: (
        <Badge variant="gradient" badgeContent="online" color="success" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          24/12/08
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
    {
      author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
      function: <Function job="Manager" org="Executive" />,
      status: (
        <Badge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          04/10/21
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
    {
      author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
      function: <Function job="Programtor" org="Developer" />,
      status: (
        <Badge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
      ),
      employed: (
        <Typography variant="caption" color="secondary" fontWeight="medium">
          14/09/20
        </Typography>
      ),
      action: (
        <Typography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          Edit
        </Typography>
      ),
    },
  ],
};

export default authorsTableData;
